import React from 'react';
import './table.scss';

import { Table as TableAntd, TableProps as TablePropsAntd } from 'antd';

const Table = ({ ...props }: TablePropsAntd<object>) => <TableAntd className="table--root" {...props} />;
export default Table;
export type { TablePropsAntd };
